import React from 'react';
import { Components } from './styled';
import ProfileAvatar from '../../../ProfileAvatar';
import { Author } from '../../../../api/types/author';

const AuthorItem = ({
  label,
  author,
  checked,
  onClick,
}: {
  label: string;
  author: Author;
  checked: boolean;
  onClick: () => void;
}) => {
  return (
    <Components.Container isSelected={checked} onClick={onClick}>
      <Components.AvatarWrapper>
        <ProfileAvatar author={author} size={32} />
        <Components.Label>{label}</Components.Label>
      </Components.AvatarWrapper>
      {checked && (
        <Components.IconWrapper>
          <Components.Icon />
        </Components.IconWrapper>
      )}
    </Components.Container>
  );
};

export default AuthorItem;
